export default __webpack_public_path__ + "static/product_category_camera-f9c7894dd6f26d44cfceb3529b8ddd41.jpg";